/**
 * Visually Hidden CSS properties
 * @description common css-properties to visually hide text and available for screen-readers.
 * There may be times where the css-specificity may not be high enough for the class to be invoked,
 * Ergo, the use of `!important` which will help ensure the properties are applied at any specificity.
 * @example
 * // usage with `react-jss`
 * import visuallyHiddenProperties from './utils/visuallyHidden';
 *
 * const useStyles = createUseStyles({
 *   srOnly: {...visuallyHiddenProperties}
 * })
 */
export default {
  border: [[0], '!important'],
  /**
   * @desc for backwards compatibility
   * @deprecated
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip
   * @see https://caniuse.com/mdn-css_properties_clip
   */
  clip: ['rect(1px, 1px, 1px, 1px)', '!important'],
  /**
   * @desc future-proof version
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path
   * @see https://caniuse.com/css-clip-path
   */
  clipPath: ['inset(50%)', '!important'],
  height: ['1px', '!important'],
  margin: ['-1px', '!important'],
  overflow: ['hidden', '!important'],
  padding: [[0], '!important'],
  position: ['absolute', '!important'],
  width: ['1px', '!important'],
  /**
   * @desc preventing text to be condensed
   * @see https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
   */
  whiteSpace: ['nowrap', '!important'],
};
